import { useStaticQuery, graphql } from "gatsby";

// prettier-ignore
const query = graphql`
  query allTranslationsQuery {
    craft {
      translationSets: globalSets(handle: ["translations"], siteId: ["not", "-1"]) {
        siteId
        ... on Craft_translations_GlobalSet {
          translationKeyValuePairs {
            labelKey
            labelValue
          }
        }
      }
    }
  }
`;

/**
 * Returns { [siteId: string]: { [labelKey: string]: string } }
 * English-default fallback keys are handled at the call site.
 */
const dataResolver = ({ craft }) => {
  const result = {};
  (craft.translationSets || []).forEach(set => {
    if (!set.siteId) return;
    const pairs = {};
    (set.translationKeyValuePairs || []).forEach(({ labelKey, labelValue }) => {
      if (labelKey) pairs[labelKey] = labelValue || "";
    });
    result[String(set.siteId)] = pairs;
  });
  return result;
};

let cache;

const useAllTranslationsData = () => {
  const response = useStaticQuery(query);
  if (cache) return cache;
  cache = dataResolver(response);
  return cache;
};

export default useAllTranslationsData;
